import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

function QrScannerWithFlip({ onScan, onError }) {
	const [cameras, setCameras] = useState([]);
	const [cameraId, setCameraId] = useState(null);
	const qrCodeRegionId = 'qr-reader';
	const qrRef = useRef();

	// Get camera list on mount
	useEffect(() => {
		Html5Qrcode.getCameras().then((devices) => {
			setCameras(devices);
			// Default: try to pick back cam, else first
			let back = devices.find((d) => d.label.toLowerCase().includes('back') || d.label.toLowerCase().includes('environment'));
			setCameraId((back && back.id) || (devices[0] && devices[0].id));
		});
		// eslint-disable-next-line
	}, []);

	// Start/stop QR code scan
	useEffect(() => {
		if (!cameraId) return;
		let html5Qr = new Html5Qrcode(qrCodeRegionId);
		html5Qr.start(
			cameraId,
			{ fps: 10, qrbox: { width: 250, height: 250 } },
			(decodedText) => onScan({ text: decodedText }),
			(errorMessage) => {
				if (onError) onError(errorMessage);
			}
		);
		qrRef.current = html5Qr;

		return () => {
			html5Qr
				.stop()
				.then(() => html5Qr.clear())
				.catch(() => {});
		};
		// eslint-disable-next-line
	}, [cameraId]);

	// UI for camera switch
	return (
		<div style={{ textAlign: 'center' }}>
			{cameras.length > 0 && (
				<select value={cameraId || ''} onChange={(e) => setCameraId(e.target.value)} style={{ marginBottom: 8 }}>
					{cameras.map((cam) => (
						<option key={cam.id} value={cam.id}>
							{cam.label || cam.id}
						</option>
					))}
				</select>
			)}
			<div id={qrCodeRegionId} style={{ width: '100%' }} />
		</div>
	);
}

export default QrScannerWithFlip;
